<template>
  <div>
    <record-info
      class="mb-100"
      :record="record"
      :status="status"
      is-large
    ></record-info>

    <record-status-selector
      class="mb-100"
      :record="record"
    ></record-status-selector>

    <record-property-detail-summary
      class="mb-100"
      :property="record.property"
    ></record-property-detail-summary>

    <record-temperature-buttons
      class="mb-200"
      :record-id="record.id"
      v-model="record.temperature"
    ></record-temperature-buttons>

    <record-next-contact
      v-show="showNextContactAt"
      class="mb-200"
      :record="record"
      show-next-month
      hide-one-hour
    ></record-next-contact>

    <notes-with-latest :record="record"></notes-with-latest>
  </div>
</template>

<script>
export default {
  name: "LeadBoxFollowUp",
  props: {
    record: {
      type: Object,
      required: true
    },
    status: {
      type: Object,
      required: true
    }
  },
  computed: {
    showNextContactAt() {
      return this.record && !this.record.current_follow_up_id;
    }
  },
};
</script>
